const DataTable = require('./DataTable');

module.exports = DataTable;
